<template>
  <v-dialog
    v-model="showDialog"
    persistent
    width="623"
    content-class="alert-dialog"
  >
    <div class="alert">
      <div class="alert__actions" v-if="showCloseButton">
        <v-btn icon @click="(showDialog = false), $emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <h4 class="alert__title" :class="{ 'alert__title--small': textSmall }">
        {{ title }}
      </h4>
      <p
        class="alert__content"
        :class="{ 'alert__content--small': textSmall }"
        v-html="content"
      ></p>
      <slot />
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "TagAlertDialog",
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    textSmall: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    selectedTagName() {
      return this.selectedTag ? this.selectedTag.name : "";
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(value) {
        this.showDialog = value;
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.alert-dialog {
  border-radius: 25px;
}
.alert {
  border-radius: 25px;
  background: white;
  padding: $spacing * 4;

  &__checkbox-container {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid $gray-300;
    max-width: 250px;
    margin: $spacing * 4 auto $spacing * 7 auto;
    border-radius: 24px;
    height: 50px;
    padding: 0 $spacing * 2.5;
    span {
      line-height: 1rem;
      @include font-size(14px);
      margin-left: $spacing * 1.5;
    }

    ::v-deep.v-input {
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }
  }
  &__actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: $spacing * 3;
  }

  &__title {
    text-align: center;
    margin-bottom: $spacing * 3;
    color: $primary;
    @include font-size(22px);

    &--small {
      @include font-size(16px);
      color: $gray-dark;
    }
  }
  &__content {
    text-align: center;
    @include font-size(16px);

    &--small {
      @include font-size(14px);
    }

    ::v-deep span {
      font-weight: bold;
      color: $primary;
    }
  }
}
</style>
